
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"35","height":"35"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"a","y1":".5","x2":"1","y2":".5","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#004387"}}),_c('stop',{attrs:{"offset":".399","stop-color":"#156ba7"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#34a3d4"}})])]),_c('circle',{attrs:{"cx":"17.5","cy":"17.5","r":"17.5","fill":"url(#a)"}}),_c('path',{attrs:{"data-name":"Union 48","d":"M15.694 24.499h-.041a1.529 1.529 0 01-1.349-.757l-4.83-4.832-.038-.036a1.528 1.528 0 01.038-2.16 1.527 1.527 0 012.159.038l4.025 4.026 10.4-10.4a1.528 1.528 0 012.16 0 1.526 1.526 0 010 2.159l-11.2 11.2a1.6 1.6 0 01-.244.314 1.532 1.532 0 01-1.08.448z","fill":"#fff"}})])
          )
        }
      }
    